module.exports = __webpack_public_path__ + "static/img/index3(1)_12.97a4b5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index3(1)_12.png
// module id = 3128
// module chunks = 1